module.exports = __webpack_public_path__ + "static/img/award5.8abafda.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award5.png
// module id = YJYP
// module chunks = 7